import { useLang } from "@/LangContext";
import { Reveal, Chapter } from "@/components/Reveal";

export default function Masterplan() {
  const { t } = useLang();

  return (
    <section
      id="plan-maestro"
      data-testid="masterplan-section"
      className="relative py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Chapter number={t.plan.chapter} label={t.plan.label} />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 max-w-3xl font-display text-3xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl">
            {t.plan.title}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
            {t.plan.subtitle}
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <figure
            data-testid="masterplan-map"
            className="group mt-14 border border-amber-400/25 bg-[#121620] p-2 transition-colors duration-500 hover:border-amber-400/50"
          >
            <div className="relative overflow-hidden">
              <img
                src="/assets/plano-maestro-pro.jpg"
                alt={t.plan.mapCaption}
                loading="lazy"
                className="w-full transition-transform duration-700 ease-out group-hover:scale-[1.02]"
              />
              <span className="absolute left-3 top-3 bg-[#0A0C10]/80 px-2.5 py-1 font-code text-[10px] uppercase tracking-[0.25em] text-amber-400 backdrop-blur-sm">
                {t.plan.label}
              </span>
            </div>
            <figcaption className="px-2 pb-2 pt-4 font-code text-[11px] uppercase tracking-[0.22em] text-slate-400">
              {t.plan.mapCaption}
            </figcaption>
          </figure>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mt-16 font-code text-xs uppercase tracking-[0.35em] text-amber-400">
            {t.plan.zonesTitle}
          </p>
        </Reveal>
        <div className="mt-6 grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {t.plan.zones.map((zone, i) => (
            <div
              key={zone.name}
              data-testid={`masterplan-zone-${i + 1}`}
              className="group bg-[#0A0C10] p-6 transition-colors duration-500 hover:bg-[#121620] sm:p-7"
            >
              <span className="font-code text-xs font-semibold tracking-[0.3em] text-amber-400">
                0{i + 1}
              </span>
              <h4 className="mt-3 font-display text-xl font-bold uppercase leading-tight text-white transition-colors group-hover:text-amber-300">
                {zone.name}
              </h4>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">
                {zone.desc}
              </p>
            </div>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p
            data-testid="masterplan-note"
            className="mt-12 max-w-3xl border-l-2 border-amber-400 pl-6 text-sm leading-relaxed text-slate-300 sm:text-base"
          >
            {t.plan.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
